module.exports = __webpack_public_path__ + "img/rating-smiley-2.310b77d1.svg";